module.exports = __webpack_public_path__ + "065979379fd6a10d4000653aeea042fa.png";